<div
  class="app-drawer"
  [attr.dir]="(translocoService.langChanges$ | async) === 'ar' ? 'rtl' : 'ltr'"
  [class.app-drawer--open]="isOpen"
>
  <button
    class="app-drawer__backdrop"
    type="button"
    [class.app-drawer__backdrop--hidden]="!showBackdrop"
    aria-label="Close drawer"
    (click)="onBackdropClick()"
  ></button>

  <aside
    class="app-drawer__panel"
    [style.width]="width"
    [style.min-width]="minWidth"
    [style.max-width]="maxWidth"
    [attr.aria-hidden]="!isOpen"
  >
    <header class="app-drawer__header">
      <div class="app-drawer__title">{{ title }}</div>
      <button class="app-drawer__close" type="button" aria-label="Close drawer" (click)="onClose()">
        <span class="material-icons-outlined">close</span>
      </button>
    </header>

    <div class="app-drawer__body">
      <ng-content></ng-content>
    </div>
  </aside>
</div>